<table mat-table [dataSource]="transitions" class="mat-elevation-z8">

  <ng-container matColumnDef="Processing Status">
    <th mat-header-cell *matHeaderCellDef> Lavorazione </th>
    <td mat-cell *matCellDef="let transition">
      <mat-chip-listbox aria-label="History">
        <mat-chip *ngIf="transition.previousProcessingStatus; else InjectionStatus">
          {{ 'enums.processingStatus.' + transition.previousProcessingStatus | translate}}</mat-chip>
        <mat-icon>arrow_right_alt</mat-icon>
        <mat-chip>{{ 'enums.processingStatus.' + transition.currentProcessingStatus | translate}}</mat-chip>
      </mat-chip-listbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="When">
    <th mat-header-cell *matHeaderCellDef> Quando </th>
    <td mat-cell *matCellDef="let transition"> {{transition.timeSpan[0] | formatDateWithTimezone | async}} </td>
  </ng-container>

  <ng-container matColumnDef="Qualification">
    <th mat-header-cell *matHeaderCellDef> Esito </th>
    <td mat-cell *matCellDef="let transition">
      <ng-container *ngIf="transition.qualificationStatus != qualificationStatus.Unknown">
        <div class="qualificationContainer">
          <mat-icon
            [ngClass]="transition.qualificationStatus == qualificationStatus.Qualified ? 'interested' : 'notInterested'">
            {{transition.qualificationStatus == qualificationStatus.Qualified ? 'thumb_up' : 'thumb_down'}}
          </mat-icon>
          <span>&nbsp; {{ 'enums.qualificationOutcome.' + transition.qualificationOutcome | translate }}</span>
        </div>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="Time in status">
    <th mat-header-cell *matHeaderCellDef> Per </th>
    <td mat-cell *matCellDef="let transition"> {{transition | humanizeTransitionSpan}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>


<ng-template #InjectionStatus>
  <div class="injectedLead"></div>
</ng-template>
